import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StoreSiteComponent } from './store-site/store-site.component';
import { PageNotFoundComponent } from 'src/app/shared/page-not-found/page-not-found.component';


const routes: Routes = [
 { path: ':formattedAddress', component: StoreSiteComponent },
 {path:'**',component:PageNotFoundComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StoreModuleRoutingModule { }
